<template>
  <Head title="Viel Erfolg!"/>

  <div class="max-w-2xl mx-auto px-4">
    <div class="examlock__msg text-center text-lg" v-html="msg">
    </div>
    <div class="mb-20"></div>
  </div>
</template>

<script>
import Layout from '../../Shared/Layout.vue'
import {Head} from '@inertiajs/inertia-vue3'
import exam from '../../Shared/Exam/Exam.vue'

export default {

  name: 'ExamLock',
  computed: {
    exam() {
      return exam
    }
  },

  components: {
    Head,
  },

  props: {
    msg: String,
  },

  layout: Layout,
}
</script>

<style scoped>

</style>